import { ITrangThaiDangKyAn } from "../../../models/response/category/ITrangThaiDangKyAn";
import {
    eTrangThaiDangKyAnActionTypeIds,
    ITrangThaiDangKyAnCloseEditModal,
    ITrangThaiDangKyAnDeleteError,
    ITrangThaiDangKyAnDeleteStart,
    ITrangThaiDangKyAnDeleteSuccess,
    ITrangThaiDangKyAnLoadError,
    ITrangThaiDangKyAnLoadStart,
    ITrangThaiDangKyAnLoadSuccess,
    ITrangThaiDangKyAnSaveError,
    ITrangThaiDangKyAnSaveStart,
    ITrangThaiDangKyAnSaveSuccess,
    ITrangThaiDangKyAnShowEditModal,
} from "../../action-types/danh-muc/ITrangThaiDangKyAnActionTypes";
import { BaseAction } from "../IBaseActionResult";

export const trangThaiDangKyAnActions = {
    LOAD_START: (_payload: undefined): ITrangThaiDangKyAnLoadStart => BaseAction(undefined, eTrangThaiDangKyAnActionTypeIds.LOAD_START),
    LOAD_SUCCESS: (payload: ITrangThaiDangKyAn[]): ITrangThaiDangKyAnLoadSuccess => BaseAction(payload, eTrangThaiDangKyAnActionTypeIds.LOAD_SUCCESS),
    LOAD_ERROR: (payload: string): ITrangThaiDangKyAnLoadError => BaseAction(payload, eTrangThaiDangKyAnActionTypeIds.LOAD_ERROR),

    SAVE_START: (payload: ITrangThaiDangKyAn): ITrangThaiDangKyAnSaveStart => BaseAction(payload, eTrangThaiDangKyAnActionTypeIds.SAVE_START),
    SAVE_SUCCESS: (_payload: undefined): ITrangThaiDangKyAnSaveSuccess => BaseAction(undefined, eTrangThaiDangKyAnActionTypeIds.SAVE_SUCCESS),
    SAVE_ERROR: (payload: string): ITrangThaiDangKyAnSaveError => BaseAction(payload, eTrangThaiDangKyAnActionTypeIds.SAVE_ERROR),

    DELETE_START: (payload: number): ITrangThaiDangKyAnDeleteStart => BaseAction(payload, eTrangThaiDangKyAnActionTypeIds.DELETE_START),
    DELETE_SUCCESS: (_payload: undefined): ITrangThaiDangKyAnDeleteSuccess => BaseAction(undefined, eTrangThaiDangKyAnActionTypeIds.DELETE_SUCCESS),
    DELETE_ERROR: (payload: string): ITrangThaiDangKyAnDeleteError => BaseAction(payload, eTrangThaiDangKyAnActionTypeIds.DELETE_ERROR),

    SHOW_EDIT_MODAL: (payload: ITrangThaiDangKyAn | undefined): ITrangThaiDangKyAnShowEditModal => BaseAction(payload, eTrangThaiDangKyAnActionTypeIds.SHOW_EDIT_MODAL),
    CLOSE_EDIT_MODAL: (_payload: undefined): ITrangThaiDangKyAnCloseEditModal => BaseAction(undefined, eTrangThaiDangKyAnActionTypeIds.CLOSE_EDIT_MODAL),
};
